module.exports = __webpack_public_path__ + "static/media/Gedruckt.e0411435.svg";